/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum Scope {
    Undefined = 0,
    Essential = 1,
    Pro = 2,
    Enterprise = 3,
    OfflineDebriefing = 4,
    Go = 5,
}
